import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HelpCenterIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_528_1576)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.4062 11.6562V13.7812",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.59375 13.7812V6.34375C1.59375 6.06196 1.7057 5.7917 1.90495 5.59245C2.1042 5.3932 2.37446 5.28125 2.65625 5.28125H5.3125",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.3303 13.7812C10.146 14.104 9.87955 14.3721 9.55811 14.5587C9.23667 14.7453 8.87166 14.8435 8.5 14.8435C8.12834 14.8435 7.76333 14.7453 7.44189 14.5587C7.12045 14.3721 6.85403 14.104 6.66967 13.7812H0.53125V14.8437C0.53125 15.4073 0.755133 15.9478 1.15365 16.3463C1.55216 16.7448 2.09266 16.9687 2.65625 16.9687H14.3437C14.9073 16.9687 15.4478 16.7448 15.8463 16.3463C16.2448 15.9478 16.4687 15.4073 16.4687 14.8437V13.7812H10.3303Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M13.2852 1.21994C12.4518 0.970886 11.5641 0.968326 10.7292 1.21257C9.89431 1.45682 9.14801 1.93744 8.58021 2.59643C8.01241 3.25543 7.64748 4.06465 7.52933 4.92645C7.41125 5.78826 7.54506 6.66583 7.91466 7.45328L6.45264 10.4205L9.79812 9.50674C10.0932 9.67582 10.4067 9.81055 10.7324 9.90837C11.8779 10.2251 13.102 10.0787 14.1405 9.50086C15.179 8.923 15.9487 7.95995 16.2835 6.81961C16.6182 5.67923 16.4911 4.45298 15.9296 3.40549C15.3682 2.35799 14.4174 1.57327 13.2824 1.22065L13.2852 1.21994Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.6987 4.51074C10.6987 4.24806 10.7766 3.99128 10.9226 3.77288C11.0685 3.55447 11.276 3.38424 11.5186 3.28372C11.7613 3.1832 12.0283 3.15689 12.286 3.20814C12.5436 3.25939 12.7802 3.38588 12.966 3.57162C13.1518 3.75736 13.2782 3.99401 13.3295 4.25164C13.3807 4.50927 13.3544 4.77631 13.2539 5.019C13.1534 5.26168 12.9831 5.4691 12.7647 5.61504C12.5463 5.76098 12.2895 5.83887 12.0269 5.83887",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.0269 7.9639C11.8802 7.9639 11.7612 7.84497 11.7612 7.69828C11.7612 7.55155 11.8802 7.43262 12.0269 7.43262",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.0269 7.9639C12.1736 7.9639 12.2925 7.84497 12.2925 7.69828C12.2925 7.55155 12.1736 7.43262 12.0269 7.43262",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_528_1576",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "17",
                        height: "17",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
